import React, { useEffect, useState } from 'react'

import { Layout, Menu, Badge } from 'antd';

import { useNavigate } from "react-router-dom";

import { ADMIN, CUSTOMER_RELATIONS_MANAGER, HOTEL_MANAGER, MANAGER, PARTNERSHIP_MANAGER, SUPER_ADMIN, SUPPORT_AGENT, TOUR_GUIDE } from '../../../../Constants/roles';

import { ADMIN_MENUS, CUSTOMER_RELATIONS_MANAGER_MENUS, HOTEL_MANAGER_MENUS, MANAGER_MENUS, PARTNERSHIP_MANAGER_MENUS, SUPER_ADMIN_MENUS, SUPPORT_AGENT_MENUS, TOUR_GUIDE_MENUS } from '../../../../Constants/roleBaseMenus';
import { fetchNewTourEnquiriesCount } from '../../../../../redux/api/inquiries.api';

import './styles.scss'

const { Sider } = Layout;

const SideBar = ({ collapsed, setCollapse, userProfile }) => {
    const [items, setItems] = useState([]);
    const [newEnquiriesCount, setNewEnquiriesCount] = useState(0);
    const navigate = useNavigate();

    useEffect(() => {
        if (userProfile) {
            let menuItems = [];
            switch (userProfile.role) {
                case SUPER_ADMIN:
                    menuItems = SUPER_ADMIN_MENUS;
                    break;
                case ADMIN:
                    menuItems = ADMIN_MENUS;
                    break;
                case MANAGER:
                    menuItems = MANAGER_MENUS;
                    break;
                case PARTNERSHIP_MANAGER:
                    menuItems = PARTNERSHIP_MANAGER_MENUS;
                    break;
                case CUSTOMER_RELATIONS_MANAGER:
                    menuItems = CUSTOMER_RELATIONS_MANAGER_MENUS;
                    break;
                case SUPPORT_AGENT:
                    menuItems = SUPPORT_AGENT_MENUS;
                    break;
                case HOTEL_MANAGER:
                    menuItems = HOTEL_MANAGER_MENUS;
                    break;
                case TOUR_GUIDE:
                    menuItems = TOUR_GUIDE_MENUS;
                    break;
                default:
                    break;
            }

            const processedItems = menuItems.map(item => {
                if (item.showBadge && item.key === 'inquiries') {
                    return {
                        ...item,
                        label: (
                            <Badge count={newEnquiriesCount} size="small" offset={[10, 0]}>
                                {item.label}
                            </Badge>
                        )
                    };
                }
                return item;
            });

            setItems(processedItems);
        }
    }, [userProfile, newEnquiriesCount]);

    useEffect(() => {
        if (userProfile) {
            fetchNewEnquiriesCount();
            const interval = setInterval(fetchNewEnquiriesCount, 30000);
            return () => clearInterval(interval);
        }
    }, [userProfile]);

    const fetchNewEnquiriesCount = async () => {
        try {
            const response = await fetchNewTourEnquiriesCount();
            if (response.status === 200) {
                const data = response.data;
                setNewEnquiriesCount(data.newEnquiriesCount);
            }
        } catch (error) {
            console.error('Failed to fetch new enquiries count');
        }
    };

    const navigateToContent = (item) => {
        const path = item?.props?.href;
        if (path) {
            navigate(`/dashboard${path}`);
        }
    }

    const getSelectedKeys = () => {
        const path = window.location.pathname;

        const pathMapping = {
            'users': 'users',
            'home': 'home',
            'inquiries': 'inquiries',
            'bookings/tour-packages': 'bookings/tour-packages',
            'bookings/flights': 'bookings/flights',
            'bookings/hotels': 'bookings/hotels',
            'bookings/transport': 'bookings/transport',
            'partners/all': 'partners/all',
            'partners/hotels': 'partners/hotels',
            'partners/transport': 'partners/transport',
            'partners/tour-guides': 'partners/tour-guides',
            'partners/restaurants': 'partners/restaurants',
            'partners/shops': 'partners/shops',
            'tours/tour-packages': 'tours/tour-packages',
            'tours/itineraries': 'tours/itineraries',
            'tours/destinations': 'tours/destinations',
            'tours/attractions': 'tours/attractions',
            'tours/activities': 'tours/activities',
            'tours/events': 'tours/events',
            'blogs': 'blogs',
            'support-tickets': 'support-tickets',
            'payments': 'payments',
            'earnings': 'earnings',
            'guide-profile': 'guide-profile',
            'guide-schedule': 'guide-schedule',
        };

        for (const key in pathMapping) {
            if (path.includes(key)) {
                return [pathMapping[key]];
            }
        }

        return [''];
    };

    return (
        <Sider
            breakpoint='md'
            collapsedWidth='0'
            collapsed={collapsed}
            onCollapse={(collapsed) => setCollapse(collapsed)}
            className='sidebar'
        >
            <div className='logo'>
                <img loading='lazy' src='https://visitpearl8abf.blob.core.windows.net/static-assets/logo.png' alt='logo' />
            </div>
            <Menu
                theme='light'
                mode='inline'
                defaultSelectedKeys={getSelectedKeys()}
                className='menu'
                style={{
                    height: '94vh',
                    overflowY: 'auto',
                }}
                items={items}
                onSelect={({ item }) => navigateToContent(item)}
            />
        </Sider>
    )
}

export default SideBar